import {
  Obj,
  currentSiteId,
  ensureUserIsLoggedIn,
  load,
  urlFor
} from "scrivito"

export function isNoSitePresent(): boolean {
  return !appWebsites()?.length
}

export async function ensureSiteIsPresent() {
  if (await load(currentSiteId)) return

  if (await load(isNoSitePresent)) {
    ensureUserIsLoggedIn()
    return
  }

  const site = await load(getPreferredSite)
  if (!site) return

  const siteUrl = await load(() => urlFor(site))
  const { pathname, search, hash } = window.location
  const path = pathname === "/" ? "" : pathname

  window.location.assign(`${siteUrl}${path}${search}${hash}`)
}

function getPreferredSite() {
  const websites = appWebsites() || []
  const preferredLanguageOrder = [...window.navigator.languages, "en", null]

  // eslint-disable-next-line no-restricted-syntax
  for (const language of preferredLanguageOrder) {
    const site = websites.find(website => siteHasLanguage(website, language))
    if (site) return site
  }

  return websites[0] || null
}

function appWebsites() {
  return Obj.onAllSites()
    .get(import.meta.env.SCRIVITO_ROOT_OBJ_ID)
    ?.versionsOnAllSites()
}

function siteHasLanguage(site: Obj, language: string | null) {
  const siteLanguage = site.language()
  return language && siteLanguage
    ? language.startsWith(siteLanguage)
    : language === siteLanguage
}
